<div [style.height]="containerHeight" *ngIf="reportConfig">
  <powerbi-paginated-report
    [embedConfig]="reportConfig"
    cssClassName="height-100-percent"
  >
  </powerbi-paginated-report>
</div>
